import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import WorkedHoursReportList, { DispatchProps, OwnProps, StateProps } from './WorkedHoursReportList';
import { StoreState } from 'src/store/reducers';
import { getWorkedHoursReports, getWorkedHoursReportsCsv } from 'src/store/actions/workedHoursReport-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.workedHoursReports.data,
        inProgress: state.workedHoursReports.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: any) => dispatch(getWorkedHoursReports(params)),
        getDataCsv: (params: any) => dispatch(getWorkedHoursReportsCsv(params)),
    };
}

const WorkedHoursReportListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(WorkedHoursReportList);

export default WorkedHoursReportListScreen;
